export default "__VITE_ASSET__BIZOob_K__"